import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {
  RECEIVABLES_IMPORT_ROW_STATUS_FOR_VERIFICATION,
  RECEIVABLES_IMPORT_ROW_STATUS_NEW, RECEIVABLES_STATEMENT_STATUS_REPORTED_FOR_SETTLEMENT
} from "../../../../shared/services/dict.service";
import {Observable, ReplaySubject} from "rxjs";
import {ReceivablesImportRow} from "../../../../shared/interface/receivables-import-row";
import {UserPermissions} from "../../../../shared/interface/user-permissions";
import {ReceivablesStatement} from "../../../../shared/interface/receivables-statement";
import {AuthService} from "../../../../shared/services/auth.service";
import {MatDialog} from "@angular/material/dialog";
import {ReceivablesImportsRowService} from "../../../../shared/services/receivables-imports-row.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {Router} from "@angular/router";
import {ReceivablesStatementService} from "../../../../shared/services/receivables-statement.service";
import {takeUntil} from "rxjs/operators";
import {ConfirmDialogComponent} from "../../../../shared/components/confirm-dialog/confirm-dialog.component";

@Component({
  selector: 'app-receivables-statement-details-view',
  templateUrl: './receivables-statement-details-view.component.html',
  styleUrls: ['./receivables-statement-details-view.component.scss']
})
export class ReceivablesStatementDetailsViewComponent implements OnInit, OnDestroy {
  @Input() receivablesStatement: Observable<ReceivablesStatement>;
  @Output() modifyClicked = new EventEmitter<any>();
  @Output() changed: EventEmitter<boolean> = new EventEmitter<boolean>();

  userPermissions: ReplaySubject<UserPermissions>;
  receivablesStatementObject?: ReceivablesStatement;
  readonly RECEIVABLES_STATEMENT_STATUS_REPORTED_FOR_SETTLEMENT = RECEIVABLES_STATEMENT_STATUS_REPORTED_FOR_SETTLEMENT;


  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private auth: AuthService,
    private dialog: MatDialog,
    private receivablesStatementService: ReceivablesStatementService,
    private snack: MatSnackBar,
    private router: Router,
  ) {
    this.userPermissions = auth.getUserPermissions();
  }

  ngOnInit(): void {
    this.receivablesStatement
      .pipe(takeUntil(this.destroyed$))
      .subscribe((receivablesStatement: ReceivablesStatement) => {
        this.receivablesStatementObject = receivablesStatement;
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  delete(): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '500px',
      data: {text: 'Czy na pewno chcesz usunąć zestawienie?'},
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.receivablesStatementService.delete(this.receivablesStatementObject.uuid)
          .subscribe(() => {
            this.snack.open('Pomyślnie usunięto zestawienie', '', {duration: 2000});
            this.router.navigate(['/naleznosci/zestawienia/lista/zgloszone_do_rozliczenia']);          });
      }
    });
  }
}
